// @mui
import { styled, alpha } from "@mui/material/styles";
import { List, ListItem } from "@mui/material";

export const ListItemStyled = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ theme, active }) => ({
  minHeight: 42,
  width: "fit-content",
  borderRadius: "20px",

  ...(active && {
    color: theme.palette.primary.dark,
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
  }),
}));

export const ListStyled = styled(List)(() => ({
  display: "flex",
  gap: 2,
  overflowX: "auto",
  scrollbarWidth: "none",
  "-ms-overflow-style": "none",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  position: "initial",
}));
